import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaPolyfillUtility from "utilities/global/sparta-polyfill-utility/1.5.1/js/sparta-polyfill-utility";

















const EVENTS = {
  FOOTNOTES_REBUILD: 'FOOTNOTES_REBUILD.footnoteUtility',
  FOOTNOTE_CLICKED: 'FOOTNOTE_CLICKED.footnoteUtility',
  RULE_QUEUECOMPLETE: 'RULE-QUEUECOMPLETE.spartaRulesUtility'
};

class footnoteUtility {
  get EVENTS() {
    return EVENTS;
  }

  constructor() {
    this.$footnoteSection = null;
    this.$footnoteLinks = null;
    this.footnoteObj = {};
    this.footnoteOrder = [];

    this.init();
  }


  init() {
    this.$footnoteSection = $('.spa-footnotes-section');


    if (!this.$footnoteSection.length) return;


    this.getFootnotes();


    this.updateFootnoteSection();


    this.updateFootnoteLinks();


    this.setupEventListeners();


    const checkForRebuild = this.checkForRebuild.bind(this);

    spartaEventsUtility.sub(this.EVENTS.FOOTNOTES_REBUILD, () => {
      checkForRebuild();
    }, true);

    spartaEventsUtility.sub(this.EVENTS.RULE_QUEUECOMPLETE, () => {
      $('[data-sparta-container]').on('webkitAnimationEnd oanimationend msAnimationEnd animationend',
        checkForRebuild());
    }, true);

    spartaEventsUtility.pub('FOOTNOTE_UTIL_RAN', true);
  }









  getFootnotes(selector=null) {
    if (!selector) {
      selector = "body";
    }

    const footnoteObj = {};
    const footnoteOrder = [];
    let footnoteIndex = 0;

    this.$footnoteLinks = $(`${selector} a[data-footnote]`);

    this.$footnoteLinks.each(function footnoteLink(i) {
      const $this = $(this);
      const thisFn = $this.data() || {};


      const uniqueId = `${$this.attr('id')}_${i}`;
      $this.attr("id", uniqueId);

      if (typeof footnoteObj[thisFn.footnote] === 'undefined') {
        thisFn.footnoteIndex = footnoteIndex;
        thisFn.footnoteLinkId = uniqueId;
        footnoteObj[thisFn.footnote] = thisFn;
        footnoteOrder.push(thisFn.footnote);
        footnoteIndex += 1;
      }
    });


    this.footnoteObj = footnoteObj;
    this.footnoteOrder = footnoteOrder;
  }





  updateFootnoteSection() {
    let newFootnotes = '<ol>';
    let counter = 0;


    const ariaLabelBack = this.$footnoteSection.data('ariaLabelBack') ? ` aria-label="${this.$footnoteSection.data('ariaLabelBack')}"` : '';

    this.footnoteOrder.forEach((fn) => {
      counter += 1;

      const backToContentLink = this.$footnoteSection.data('backContent') ? ` <a href="#${this.footnoteObj[fn].footnoteLinkId}"${ariaLabelBack} class="spa-footnote-back">${this.$footnoteSection.data('backContent')}</a>` : '';

      newFootnotes += `<li><div id="ftn_${this.footnoteObj[fn].footnote}_content" class="ftn-wrapper">${this.footnoteObj[fn].footnoteContent}${backToContentLink}</div></li>`;
    }, this);

    newFootnotes += '</ol>';


    this.$footnoteSection.html(newFootnotes);
  }





  updateFootnoteLinks() {
    for (let i = 0; i < this.footnoteOrder.length; i += 1) {
      const index = i + 1;
      const $thisFn = $(`a[data-footnote=${this.footnoteObj[this.footnoteOrder[i]].footnote}]`);
      const newContent = `<span class="ada-hidden">Footnote </span>${index}`;

      $thisFn.find('span.spa-footnote-order').html(newContent);
    }
  }






  setupEventListeners() {
    $('body').on('click.footnoteLink', 'a[id^="ftn_"]', function footnoteLinkClick(e) {
      e.preventDefault();
      e.stopPropagation();



      spartaEventsUtility.pub(EVENTS.FOOTNOTE_CLICKED, e);


      const footnoteLink = this;


      const targetSelector = document.querySelector(`#ftn_${footnoteLink.dataset.footnote}_content`);
      if (targetSelector) {
        const backToContentTarget = footnoteLink.getAttribute("id");
        const backToContentLink = targetSelector.querySelector(".spa-footnote-back");
        if (backToContentLink) {
          backToContentLink.setAttribute("href", `#${backToContentTarget}`);
        }
      }

      const $target = $(`#ftn_${footnoteLink.dataset.footnote}_content`);
      const $panelToggle = $('[data-toggle="#panel-legal"]');
      const $panelToggleHeader = $panelToggle.parents('.spa-toggle-heading');



      let offset = 60;
      let targetOffset = $target.offset();
      targetOffset = targetOffset ? targetOffset.top - offset : 0;
      let stickyOffset = 0;

      if (!$panelToggleHeader.hasClass('active')) {
        $panelToggle.find('> span').addClass('active');
        $panelToggleHeader.addClass('active');

        $('#panel-legal').addClass('active').slideDown({
          complete: function stickySlideDownComplete() {


            offset = 60;

            stickyOffset = footnoteUtility.getStickyOffset();
            offset = stickyOffset > offset ? stickyOffset : offset;
            targetOffset = $target.offset();
            targetOffset = targetOffset ? targetOffset.top - offset : 0;

            footnoteUtility.scrollToTarget($target, targetOffset);
          },
        });
      } else {
        stickyOffset = footnoteUtility.getStickyOffset();
        offset = stickyOffset > offset ? stickyOffset : offset;
        targetOffset = $target.offset();
        targetOffset = targetOffset ? targetOffset.top - offset : 0;
        footnoteUtility.scrollToTarget($target, targetOffset);
      }

    });


    $('[data-sparta-container]').on('blur.footnoteBack touchend.footnoteBack', '.spa-footnote-back', () => {
      $('.spa-footnote-back').css('display', 'none');
      $('.spa-footnotes-section .ftn-wrapper').removeAttr('tabindex');
    });

    $('body').on('click.footnoteBack touchstart.footnoteBack', '.spa-footnote-back', function footnoteBackClick(e) {
      e.preventDefault();
      e.stopPropagation();

      const $backLink = $(this);
      const $footnoteLink = $($backLink.attr('href'));

      if ($footnoteLink.is(':visible')) {
        let linkOffset = $footnoteLink.offset();
        linkOffset = linkOffset ? linkOffset.top - footnoteUtility.getStickyOffset() : 0;
        footnoteUtility.scrollToTarget($footnoteLink, linkOffset);
      }
    });


    $('body').on('focus.footnote', '.spa-footnotes-section .ftn-wrapper', function footnoteFocus() {
      const $backLink = $(this).find('.spa-footnote-back');
      const $footnoteLink = $($backLink.attr('href'));


      if ($footnoteLink.is(':visible') && this.getAttribute('tabindex')) {
        $backLink.css('display', 'inline');
      }
    });
  }

  checkForRebuild() {
    const oldLinks = this.$footnoteLinks;
    let newLinks = [];

    if (!oldLinks) {
      this.rebuildFootnotes();
    } else {
      newLinks = $('a[data-footnote]');

      if (newLinks.length !== oldLinks.length) {
        this.rebuildFootnotes();
      } else {
        for (let i = 0; i < newLinks.length; i += 1) {
          if (newLinks[i] !== oldLinks[i]) {
            this.rebuildFootnotes();
            return;
          }
        }
      }
    }
  }





  rebuildFootnotes(selector=null) {

    if (this.$footnoteSection) {

      this.$footnoteSection.html();


      this.getFootnotes(selector);


      this.updateFootnoteSection();


      this.updateFootnoteLinks();
    }
  }

  static getStickyOffset() {
    let stickyOffset = 0;
    $('.spa-sticky').each(function spaStickyOffset() {
      stickyOffset += $(this).outerHeight();
    });
    return stickyOffset;
  }

  static scrollToTarget($el, targetOffset) {
    $('html, body').animate({
      scrollTop: targetOffset,
    }, 250, () => {
      if (($el).is('.spa-footnotes-section .ftn-wrapper')) {
        $el.attr('tabindex', '-1').focus();
      } else {
        $el.focus();
      }
    });
  }





  dynamicFootnotes() {











































































  }
}

export default new footnoteUtility();
